import React from 'react';
import { useTreatment } from '@surfline/quiver-react';
import { SL_WEB_CONDITION_VARIATION } from './treatments';

const withSevenRatingsVariation = (WrappedComponent) => {
  const WrappedWithSevenRatingsVariation = (props) => {
    const { treatment, loading } = useTreatment(SL_WEB_CONDITION_VARIATION);
    if (loading) {
      return <div className="sl-sevenratings-variant-wrapper" />;
    }

    return <WrappedComponent {...props} sevenRatings={treatment === 'on'} />;
  };
  WrappedWithSevenRatingsVariation.propTypes = {};
  WrappedWithSevenRatingsVariation.defaultProps = {};
  return WrappedWithSevenRatingsVariation;
};

export default withSevenRatingsVariation;
